/**
 * Valida si una factura CCF puede ser anulada (solo el mismo día)
 */
export const esCCFMismoDia = (invoice) => {
  if (invoice.tipo_documento !== '03') return true;
  
  const fechaEmision = new Date(invoice.fecha_emision).toDateString();
  const hoy = new Date().toDateString();
  
  return fechaEmision === hoy;
};

/**
 * Valida el rango de fechas
 */
export const validarRangoFechas = (fromDate, toDate) => {
  if (!fromDate || !toDate) {
    return {
      valido: false,
      mensaje: "Debes seleccionar ambas fechas"
    };
  }

  if (new Date(fromDate) > new Date(toDate)) {
    return {
      valido: false,
      mensaje: "La fecha inicial no puede ser mayor a la fecha final"
    };
  }

  return { valido: true };
};

/**
 * Valida el motivo de anulación
 */
export const validarMotivoAnulacion = (motivo, longitudMinima = 10) => {
  if (motivo.trim().length < longitudMinima) {
    return {
      valido: false,
      mensaje: `El motivo debe tener al menos ${longitudMinima} caracteres`
    };
  }

  return { valido: true };
};

/**
 * Obtiene el tipo de documento en texto legible
 */
export const getTipoDocumentoTexto = (tipoDocumento) => {
  const tipos = {
    '01': 'Consumidor Final',
    '03': 'Crédito Fiscal',
    '14': 'Nota de Crédito'
  };
  
  return tipos[tipoDocumento] || 'Desconocido';
};

/**
 * Verifica si una factura puede ser anulada
 */
export const puedeAnularseFactura = (invoice) => {
  // Consumidor final puede anularse siempre
  if (invoice.tipo_documento === '01') {
    return { puede: true, motivo: null };
  }

  // Crédito fiscal solo el mismo día
  if (invoice.tipo_documento === '03') {
    if (esCCFMismoDia(invoice)) {
      return { puede: true, motivo: null };
    }
    return {
      puede: false,
      motivo: 'Las facturas de Crédito Fiscal solo pueden anularse el mismo día de emisión'
    };
  }

  return { puede: false, motivo: 'Tipo de documento no válido para anulación' };
};

// ============================================================================
// 🆕 NUEVAS FUNCIONES PARA DESCARGA DE JSON DE INVALIDACIÓN
// ============================================================================

/**
 * Descarga el archivo JSON de invalidación de una factura anulada
 * @param {string} filename - Nombre del archivo (ej: "invalidacion_DTE-01-M001P001-000000000000014_20260128215210.json")
 * @param {string} token - Token de autenticación (opcional, se lee de localStorage si no se pasa)
 */
export const descargarJsonInvalidacion = async (filename, token = null) => {
  const authToken = token || localStorage.getItem('token');
  
  if (!authToken) {
    throw new Error('No estás autenticado. Por favor inicia sesión.');
  }
  
  try {
    const response = await fetch(
      /*`http://localhost:8085/api/invoices/invalidacion/download/${filename}`,*/
         `https://restaurante.altivaweb.com/BACK/public/api/invoices/invalidacion/download/${filename}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Accept': 'application/json',
        }
      }
    );
    
    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('No autorizado. Tu sesión puede haber expirado.');
      }
      if (response.status === 404) {
        throw new Error('Archivo no encontrado.');
      }
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    // Convertir respuesta a blob
    const blob = await response.blob();
    
    // Crear URL temporal
    const url = window.URL.createObjectURL(blob);
    
    // Crear elemento <a> temporal para descargar
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    
    // Limpiar
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    console.log('✅ Archivo descargado exitosamente');
    return true;
    
  } catch (error) {
    console.error('❌ Error al descargar:', error);
    throw error;
  }
};

/**
 * Extrae el nombre del archivo desde la ruta completa
 * @param {string} path - Ruta completa (ej: "invalidaciones/invalidacion_DTE-01-M001P001-000000000000014_20260128215210.json")
 * @returns {string} - Nombre del archivo
 */
export const getFilenameFromPath = (path) => {
  if (!path) return '';
  return path.split('/').pop();
};

/**
 * Verifica si una factura tiene JSON de invalidación disponible
 * 🔧 CORREGIDO - Ahora busca en invoice.invalidacion.json_invalidacion_path
 * @param {object} invoice - Objeto de factura con relación invalidacion cargada
 * @returns {boolean}
 */
export const tieneInvalidacionDisponible = (invoice) => {
  // Verificar que esté anulada Y que tenga la relación invalidacion cargada
  return (
    invoice?.estado_dte === 'ANULADO' && 
    invoice?.invalidacion?.json_invalidacion_path
  );
};

/**
 * Obtiene la ruta del JSON de invalidación desde una factura
 * @param {object} invoice - Objeto de factura
 * @returns {string|null} - Ruta del archivo o null
 */
export const getInvalidacionPath = (invoice) => {
  return invoice?.invalidacion?.json_invalidacion_path || null;
};